export const paths = {
  memberDirectory: '/member-directory',
};
